import type { ReactNode } from "react";

/**
 * Successful lists always get a numeric pill, including `0`. Failed lists get
 * a failed marker — never a fake `0` and never a missing pill that looks like
 * the count was never implemented. `undefined` count while loading means no
 * pill (do not invent `0`).
 */
export function iamTabBadge(
  isError: boolean,
  count: number | undefined,
  failedLabel: string,
): ReactNode | undefined {
  if (isError) {
    return (
      <span aria-label={failedLabel} title={failedLabel}>
        !
      </span>
    );
  }
  return count;
}
